import React from 'react';
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Avatar from '@mui/material/Avatar';

import Container from 'components/Container';

const mock = [
  {
    image: '',
    description: ' My school strongly believes in providing good education by encouraging students todevelop their talents like dance, music, yoga, arts, debates, mad ads, speech, extempore etc. Each class is assigned to conduct the morning assembly for a week, which is both informative and enjoyable. We also have well equipped library and laboratories.',
    title: 'Divya Deshpande V - B',
    
    author: {
      name: 'Divya Deshpande V - B',
      avatar: '',
    },
  
  },
  
  {
    image: '',
    description: 'Good infrastructure and spacious classrooms with good ventilation and the comfortable dual desks definitely make students feel like learning. Knowledge is given to each of the student. Co-Curricular activities are also given equal importance. Apart from school exams, children are also motivated to participate in other state level and national level exams. Rules and values of the school are a bit complicated but will definitely help us in our future.',
    title: 'Janhavi J VII-B',
    author: {
      name: 'Janhavi J VII-B',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'We are proud of our spacious and airy classrooms. Teachers are very kind and polite. Their teaching is very good and they clear all my doubts. Many activities, FAs and competitions are conducted periodically. ',
    title: 'Kennitha Patil VII-A',
    author: {
      name: 'Kennitha Patil VII-A',
      avatar: '',
    },
    date: '',
  },
 
  {
    image: '',
    description: 'I have learnt many moral values which are bound to help me in future endeavours.',
    title: 'Vineeth VIII-B',
    
    author: {
      name: 'Vineeth VIII-B',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'The FAs conducted teach us to speak in front of a huge crowd, which helps us, to be bold in front of many people.',
    title: 'Vipula H VIII-A',
    
    author: {
      name: 'Vipula H VIII-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: " It's like my second home and all the teachers here are children friendly and encouraging. I am happy that I am getting an opportunity to explore myself and to showcase my talents. So my parents are happy about it. One great achievement that I have gained after joining NPSYPR is that my stage fear has vanished",
    title: 'Taaniya J VIII-A',
    
    author: {
      name: 'Taaniya J VIII-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'I was in Cloud-9 when I joined NPS. Teachers are very supportive, kind and clarify our doubts every time if we dont understand concept. I love coming to school and am living in my dream school.',
    title: 'Vidhula H VIII-B',
   
    
    author: {
      name: 'Vidhula H VIII-B',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'The best part of my school is cleanliness.',
    title: 'Madhushreyas V-A',
   
    
    author: {
      name: 'Madhushreyas V-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'I feel whoever enters this school will become a disciplined child and a scholar.',
    title: 'Sushmita M Rane V-A',
   
    
    author: {
      name: 'Sushmita M Rane V-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: "National Public school is widely known for its discipline and excellence in all fields. It is identified for the students'  talent and brilliance. Students become punctual which is a necessity for a successful future.",
    title: 'Shravana VIII-A',
    author: {
      name: 'Shravana VIII-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'The benches are very comfortable to sit and work on. The water which is provided to drink is filtered and pure.',
    title: 'Suraj Suresh VII-B ',
    
    author: {
      name: 'Suraj Suresh VII-B',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'The teachers are amiable and amicable with the students. The atmosphere of the school is student friendly. I have improved a lot in my academics because of the encouragement given by the teachers.',
    title: 'B Ashvin IX-A',
    author: {
      name: 'B Ashvin IX-A',
      avatar: '',
    },
    date: '',
  },
  
  {
    image: '',
    description: 'School maintains 100% cleanliness and expects the same from the students. The school takes care of our future. They work for our benefit. This makes me feel proud about studying in this school.',
    title: 'Sampada S Joshi IX-A',
    author: {
      name: 'Sampada S Joshi IX-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'NPS is where almost every child dreams to come . The classrooms are very well ventilated and spacious.It is good that the morning assemble is held in the school ground as students get fresh air and sunlight.',
    title: 'Poorvika Ojha VIII-B',
    author: {
      name: 'Poorvika Ojha VIII-B',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'There is a lot of difference seen in me, before I used to be scared to face audience, but NPS has given me many chances to perform on the stage in front of the whole school and now I am confident. Students are trained well in all categories like academics, sports, art, oratory skills and personality development',
    title: 'Sneha Jain IX-B ',
    author: {
      name: 'Sneha Jain IX-B ',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'The classroom is absolutely clean, bright and colourful. The pleasant smile of my friends and teachers made me feel colourful. When I feel that I am missing something around me, I then realize that it was noise and chaos. After spending a year in this school, now I feel that the school has taught us to be disciplined, responsible and respectful. As people say it is not strict but disciplined. The simplicity they have taught us and the guidance given will help us to lead a better life in future. I just love going to school every day.',
    title: 'Preethi Basavaraju VI-C',
  
    author: {
      name: 'Preethi Basavaraju VI-C',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'What they meant by discipline is doing the right thing at the right place at the right time. I think this is the NPS secret to success. I am sure I will take immense pleasure in calling NPS my alma-mater.',
    title: 'Akshay V IX-B',
    author: {
      name: 'Akshay V IX-B',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'All students are provided equal opportunity to showcase their talent be it girls or boys. We are encouraged to work and study in groups to develop team spirit. We are groomed to be good human beings.',
    title: 'Vanshika VII-A ',
    author: {
      name: 'Vanshika VII-A ',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: ' It is a pleasure to come to a school like NPS YPR. It is surely a place where all your dreams come true. A place where you can discover your inner self.',
    title: '  Aditi V VIII-A ',

    author: {
      name: 'Aditi V VIII-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: ' All my teachers are very kind in nature and well educated. NPS has very good infrastructure, facilities like science-lab, computer centre, math lab, audio visual room, auditorium, media, health centre and a vast library which is the most interesting part of the school. The school encourages us to participate in competitive programmes. ',
    title: 'Nanda Rishik B V-A ',
    author: {
      name: 'Nanda Rishik B V-A',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'NPS is eco-friendly. We have four houses in the school - Aether, Aura, Athena and Asterea.',
    title: 'Rohit R M V-A ',
    author: {
      name: 'Rohit R M',
      avatar: '',
    },
    date: '',
  },
  {
    image: '',
    description: 'It has changed my attitude towards people and has also made me active, encouraged me to participate in many activities.    ',
    title: 'K.M Bhuvan   IX-A    ',
    author: {
      name: 'K.M Bhuvan  IX-A   ',
      avatar: '',
    },
    date: '',
  },
];

const Hero = () => {
  const theme = useTheme();
  return (
    <Container>
      <Grid container spacing={4}>
        {mock.map((item, i) => (
          <Grid item xs={12} md={4} key={i}>
            <Box
              // component={'a'}
              href={''}
              display={'block'}
              width={1}
              height={1}
              sx={{
                textDecoration: 'none',
                transition: 'all .2s ease-in-out',
                '&:hover': {
                  transform: `translateY(-${theme.spacing(1 / 2)})`,
                },
              }}
            >
              <Box
                component={Card}
                width={1}
                height={1}
                boxShadow={4}
                display={'flex'}
                flexDirection={'column'}
                sx={{ backgroundImage: 'none' }}
              >
              
                <Box component={CardContent} position={'relative'}>
                  <Typography variant={'h6'} gutterBottom>
                    {item.title}
                  </Typography>
                  <Typography color="text.secondary">
                    {item.description}
                  </Typography>
                </Box>
                <Box flexGrow={1} />
                <Box padding={2} display={'flex'} flexDirection={'column'}>
                  <Box marginBottom={2}>
                    <Divider />
                  </Box>
                  <Box
                    display={'flex'}
                    justifyContent={'space-between'}
                    alignItems={'center'}
                  >
                    <Box display={'flex'} alignItems={'center'}>
                      <Avatar
                        src={item.author.avatar}
                        sx={{ marginRight: 1 }}
                      />
                      <Typography color={'text.secondary'}>
                        {item.author.name}
                      </Typography>
                    </Box>
                    <Typography color={'text.secondary'}>
                      {item.date}
                    </Typography>
                  </Box>
                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
        <Grid item container justifyContent={'center'} xs={12}>
        
        </Grid>
      </Grid>
    </Container>
  );
};

export default Hero;